import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/IndexView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('../views/ScheduleView.vue')
  },
  {
    path: '/massages',
    name: 'massages',
    component: () => import('../views/MassagesView.vue')
  },
  {
    path: '/drink-operations',
    name: 'drink-operations',
    component: () => import('../views/DrinkOperationsView.vue')
  },
  {
    path: '/masseuses',
    name: 'masseuses',
    component: () => import('../views/MasseusesView.vue')
  },
  {
    path: '/masseuse/:contract_id',
    name: 'masseuse-insights',
    component: () => import('../views/MasseuseInsightsView.vue')
  },
  {
    path: '/staff',
    name: 'staff',
    component: () => import('../views/StaffView.vue')
  },
  {
    path: '/masseuse/:id/balance',
    name: 'masseuse-balance',
    component: () => import('../views/MasseuseBalanceView.vue')
  },
  {
    path: '/absences',
    name: 'absences',
    component: () => import('../views/AbsencesView.vue')
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import('../views/AnalysisView.vue')
  },
  {
    path: '/stats',
    name: 'stats',
    component: () => import('../views/StatsView.vue')
  },
  {
    path: '/daily',
    name: 'daily',
    component: () => import('../views/DailyView.vue')
  },
  {
    path: '/staff-schedule',
    name: 'staff-schedule',
    component: () => import('../views/StaffScheduleView.vue')
  },
  {
    path: '/programs',
    name: 'programs',
    component: () => import('../views/ProgramsView.vue')
  },
  {
    path: '/drinks',
    name: 'drinks',
    component: () => import('../views/DrinksView.vue')
  },
  {
    path: '/drinks/prices',
    name: 'drinks-prices',
    component: () => import('../views/DrinksPricesView.vue')
  },
  {
    path: '/drink-stock',
    name: 'drink-stock',
    component: () => import('../views/DrinkStockView.vue')
  },
  {
    path: '/cron',
    name: 'cron',
    component: () => import('../views/CronView.vue')
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('../views/NotificationsView.vue')
  },
  {
    path: '/settings/analysis-types',
    name: 'analysis-types',
    component: () => import('../views/AnalysisTypesView.vue')
  },
  {
    path: '/settings/check-list-types',
    name: 'check-list-types',
    component: () => import('../views/CheckListTypesView.vue')
  },
  {
    path: '/settings/check-list-types/:id',
    name: 'check-list-type-detail',
    component: () => import('../views/CheckListTypeDetailView.vue')
  },
  {
    path: '/settings/marketing-channels',
    name: 'marketing-channels',
    component: () => import('../views/MarketingChannelsView.vue')
  },
  {
    path: '/settings/roles',
    name: 'roles',
    component: () => import('../views/RolesView.vue')
  },
  {
    path: '/not_allowed',
    name: 'not-allowed',
    component: () => import('../views/NotAllowedView.vue')
  },
  {
    path: '/salon/shift-balance',
    name: 'salon-shift-balance',
    component: () => import('../views/SalonShiftBalanceView.vue')
  },
  {
    path: '/certificates',
    name: 'certificates',
    component: () => import('../views/CertificatesView.vue')
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/ReportsView.vue')
  },
  {
    path: '/reports/leads',
    name: 'reports-leads',
    component: () => import('../views/ReportLeadsView.vue')
  },
  {
    path: '/reports/masseuses',
    name: 'reports-masseuses',
    component: () => import('../views/ReportMasseusesView.vue')
  },
  {
    path: '/reports/programs',
    name: 'reports-programs',
    component: () => import('../views/ReportProgramsView.vue')
  },
  {
    path: '/reports/salon-load',
    name: 'reports-salon-load',
    component: () => import('../views/ReportSalonLoadView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router